import React from 'react'
import { Outlet } from 'react-router-dom'
import { usePostHog } from 'posthog-js/react'

import NavBar from '../components/navbar'
import Footer from '../components/layout/Footer'
import { CurrentUserContext, useAuth } from '../../libraries/auth'

interface Props {
  fullHeight?: boolean
  hideNavBar?: boolean
  hideFooter?: boolean
  noPadding?: boolean
}

const MasterPage: React.FC<Props>  = ({ fullHeight, hideNavBar, hideFooter, noPadding }) => {
  const { logout } = useAuth()
  const { currentUser } = React.useContext(CurrentUserContext)
  const posthog = usePostHog()
  const handleSignOut = () => {
    if(logout) {
      logout()
      posthog.reset()
    }
  }

  const renderNavBar = () => !hideNavBar && <NavBar onSignOut={handleSignOut} userFullName={`${currentUser?.name} ${currentUser?.lastName}`} />
  const renderFooter = () => !hideFooter && <Footer />

  const padding = noPadding ? '' : 'px-5 md:px-10'
  const FullHeight = () => (
    <div className='max-w-screen-xl mx-auto h-screen flex flex-col box-content'>
      <div className={`overflow-y-auto ${padding} pt-2 max-w-full flex-1 flex flex-col h-5/6`}>
        {renderNavBar()}
        <div className='flex-1'><Outlet /></div>
      </div>
    </div>
  )

  const FreeHeight = () => (
    <div className={`${padding} flex flex-col max-w-screen-xl mx-auto block min-h-screen box-content`}>
      <div className={`${hideNavBar ? 'pt-0' : 'pt-6' } flex grow flex-col`}>
        {renderNavBar()}
        <Outlet />
      </div>
      {renderFooter()}
    </div>
  )

  return fullHeight ? <FullHeight /> : <FreeHeight />
}

export default MasterPage
